import {V3Record} from 'data/helpers/V3Record.js'

export const LiveLog = V3Record('liveLog', {
  id: null,
  userId: null,
  tripId: null,
  routeId: null,
  updatedAt: null,
  assetType: null,
  assetId: null,
  battery: null,
  signal: null,
  service: null,
  roaming: null,
  distanceAlong: null,
  eta: null,
  finalized: null
})
